module.exports = __webpack_public_path__ + "db57bb44d034aaf92f5f1f17360eb425.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.woff?t=1557132315021
// module id = 13
// module chunks = 0